import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios, { getParams } from '@utils/request'
import { IListQueryPaginationPayload } from '@app-store/slices/meetingRequests/listHallByToken'

interface TaskAction extends Action {
    payload: IListQueryPaginationPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.meetingRequests.listHallByToken

function* listMeetingRequestSagaTask({ payload }) {
    const params = yield getParams(payload)

    try {
        const response = yield axios.get(`/meeting/meeting-requests/halls`, {
            params: {
                ...params,
                token: payload.token
            }
        })
        if (response.success) {
            yield put(onSuccess(response.result))
            if (payload?.sagaCB?.onSuccess) payload.sagaCB.onSuccess()
        } else {
            if (payload?.sagaCB?.onError) payload?.sagaCB?.onError()
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* listMeetingRequestSaga(): any {
    yield takeLatest<TaskAction>(onRequest, listMeetingRequestSagaTask)
}

export default listMeetingRequestSaga
